import React, { useState } from "react";

import { dataportfolio, meta } from "../../assets/content";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Container, Row, Col } from "react-bootstrap";
import { FaLink, FaMagnifyingGlass } from "react-icons/fa6";
import FsLightbox from "fslightbox-react";
import { motion, AnimatePresence } from "framer-motion";

import "./styles.css";

const categories = [
  { label: "All", value: "*" },
  { label: "Print", value: "print" },
  { label: "Web / Design", value: "webdesign" },
  { label: "UX", value: "ux" },
  { label: "Responsive", value: "responsive" },
  { label: "Games", value: "games" },
  { label: "Apps", value: "apps" },
  { label: "React", value: "react" },
];

// Animation variants
const containerVariants = {
  visible: {
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.1,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, scale: 0.95 },
  visible: { opacity: 1, scale: 1 },
  exit: { opacity: 0, scale: 0.9 },
};

export default function Portfolio() {
  const [filter, setFilter] = useState("*");

  const [lightboxController, setLightboxController] = useState({
    toggler: false,
    slide: 1,
  });

  const filteredItems =
    filter === "*"
      ? dataportfolio
      : dataportfolio.filter((item) => item.category.includes(filter));

  const lightboxSources = filteredItems
    .filter((item) => item.bigImage)
    .map((item) => item.bigImage);

  const handleLightboxOpen = (itemId) => {
    const index = filteredItems
      .filter((item) => item.bigImage)
      .findIndex((item) => item.id === itemId);

    setLightboxController({
      toggler: !lightboxController.toggler,
      slide: index + 1,
    });
  };

  return (
    <HelmetProvider>
      <Container className="About-header">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Portfolio | {meta.title}</title>
          <meta name="description" content={meta.description} />
        </Helmet>

        <Row className="mb-1 mt-3 pt-md-3">
          <Col lg="12">
            <h1 className="display-4 mb-4">Portfolio</h1>
            <hr className="t_border my-4 ml-0 text-left" />
          </Col>
        </Row>

        {/* Filter */}
        <Row className="mb-4">
          <Col lg="12">
            <div className="portfolioFilter">
              <ul>
                {categories.map((cat) => (
                  <li key={cat.value}>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setFilter(cat.value);
                      }}
                      className={filter === cat.value ? "current" : ""}
                    >
                      {cat.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </Col>
        </Row>

        {/* Portfolio items */}
        <Row>
          <Col lg="12">
            <motion.ul
              className="portfolioContainer po_items_ho"
              variants={containerVariants}
              initial="hidden"
              animate="visible"
              layout
            >
              <AnimatePresence>
                {filteredItems.map((item) => (
                  <motion.li
                    key={item.id}
                    className="isotope-item text-center"
                    variants={itemVariants}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                    transition={{ duration: 0.3 }}
                    layout
                  >
                    <div className="lightCon text-center">
                      <span className="hoverBox">
                        <span className="smallIcon">
                          {item.bigImage && (
                            <a
                              className="zoom lb lb_warsaw1"
                              onClick={() => handleLightboxOpen(item.id)}
                              title={`Zoom in on ${item.title}`}
                            >
                              <FaMagnifyingGlass className="search-icon" />
                            </a>
                          )}
                          {item.link && (
                            <a
                              href={item.link}
                              title={item.title}
                              target="_blank"
                              rel="noreferrer"
                              className="linKed"
                            >
                              <FaLink className="link-icon" />
                            </a>
                          )}
                        </span>
                      </span>
                      <img
                        src={item.image}
                        alt={`${item.title} thumbnail`}
                        loading="lazy"
                      />
                    </div>
                  </motion.li>
                ))}
              </AnimatePresence>
            </motion.ul>
          </Col>
        </Row>

        {/* Lightbox */}
        <FsLightbox
          toggler={lightboxController.toggler}
          sources={lightboxSources}
          slide={lightboxController.slide}
        />
      </Container>
    </HelmetProvider>
  );
}
